import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/Button/Button';
import { AiOutlineLoading } from "react-icons/ai";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { thaiCourseList, chinaCourseList, malaysiaCourseList, taiwanCourseList, chinaOnlineCourseList } from '../../utils/constant';
import { errorToast } from '../../utils/errorHandling';
import { Divider, Select, Space } from 'antd';
import { postExperienceById } from '../../services/experience';

const base_url = process.env.REACT_APP_BASE_URL

const CreateExperience = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const openDropdownsRef = useRef(0); // Track the number of open dropdowns
    const isOnlineStudent = localStorage.getItem("isOnlineStudent") === 'true';
    const navigate = useNavigate();

    useEffect(() => {
        setFormData({
            thai_course: {
                thai_course_1: "0",
                thai_course_2: "0",
                thai_course_3: "0",
                thai_course_4: "0",
                thai_course_5: "0",
                thai_course_6: "0",
                thai_course_7: "0",
                thai_course_8: "0",
                thai_course_9: "0",
                thai_course_10: "0",
                thai_course_11: "0",
                thai_course_12: "0",
                thai_course_13: "0",
            },
            malaysia_course: {
                malaysia_course_1: "0",
                malaysia_course_2: "0",
            },
            taiwan_course: {
                taiwan_course_1: "0",
            },
            china_course: {
                china_course_1: "0",
            },
            online: {
                china_online_course_1: "0",
                china_online_course_2: "0",
                china_online_course_3: "0",
                china_online_course_4: "0",
                china_online_course_5: "0",
                china_online_course_6: "0",
                china_online_course_7: "0",
                china_online_course_8: "0",
                china_online_course_9: "0",
            },
        })
    }, []);

    useEffect(() => {
        if (isDropdownOpen) {
            document.body.style.overflow = 'hidden'; // Disable body scroll
        } else {
            document.body.style.overflow = 'auto';  // Re-enable body scroll
        }
    }, [isDropdownOpen]);

    const handleDropdownVisibleChange = (open) => {
        // Update the ref count
        if (open) {
            openDropdownsRef.current += 1; // Increment when a dropdown opens
        } else {
            openDropdownsRef.current -= 1; // Decrement when a dropdown closes
        }

        // Update the state based on the ref count
        setIsDropdownOpen(openDropdownsRef.current > 0);
    };

    const handleThaiCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            thai_course: {
                ...prevState.thai_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.thai_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleMalaysiaCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            malaysia_course: {
                ...prevState.malaysia_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.malaysia_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleOnlineCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            online: {
                ...prevState.online,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.online).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleTaiwanCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            taiwan_course: {
                ...prevState.taiwan_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.taiwan_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };
    const handleChinaCourseChange = (value) => {
        setFormData((prevState) => ({
            ...prevState,
            china_course: {
                ...prevState.china_course,
                // Set selected courses to "1", others remain unchanged
                ...Object.fromEntries(
                    Object.keys(prevState.china_course).map((key) => [
                        key,
                        value.includes(key) ? "1" : "0",
                    ])
                ),
            },
        }));
    };

    const handleCancel = () => {
        navigate(isOnlineStudent ? `${base_url}/online_view_experience` : `${base_url}/view_experience`)
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await postExperienceById({ exp_data: formData });
            if (response) {
                toast.success(t("Experience.submitSuccess"));
                navigate(isOnlineStudent ? `${base_url}/online_view_experience` : `${base_url}/view_experience`)
            }
        } catch (error) {
            errorToast(error, t("general.failSubmit"), t);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className='info-container'>
                <h3>{t("Experience.retreat_experience")}</h3>
                <p>{t("general.Des3rd")}</p>
                <div className='action-buttons'>
                    <Button buttonStyle='btn--primary' buttonSize='btn--small' onClick={handleCancel} type="button">{t("general.BTNcancel")}</Button>
                </div>
            </div>
            <div className='form-wrapper'>
                <form>
                    <h5 className='mt-3'>{t("Experience.instruction")}</h5>
                    <div className="form-item">
                        <label>{t("Experience.thai_course")}</label>
                        <Select
                            mode="multiple"
                            style={{
                                width: '100%',
                            }}
                            size='large'
                            showSearch={false}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            placeholder={t("Experience.instruction")}
                            onChange={handleThaiCourseChange}
                            options={thaiCourseList(t)}
                            optionRender={(option) => (
                                <Space direction='vertical'>
                                    <span style={{ color: "#e67300" }}>
                                        {option.data.label}
                                    </span>
                                    <span style={{ color: "#575655" }}>
                                        {option.data.date}
                                    </span>
                                    <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                </Space>
                            )}
                        />
                    </div>
                    <div className="form-item">
                        <label>{t("Experience.malaysia_course")}</label>
                        <Select
                            mode="multiple"
                            style={{
                                width: '100%',
                            }}
                            size='large'
                            showSearch={false}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            placeholder={t("Experience.instruction")}
                            onChange={handleMalaysiaCourseChange}
                            options={malaysiaCourseList(t)}
                            optionRender={(option) => (
                                <Space direction='vertical'>
                                    <span style={{ color: "#e67300" }}>
                                        {option.data.label}
                                    </span>
                                    <span style={{ color: "#575655" }}>
                                        {option.data.date}
                                    </span>
                                    <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                </Space>
                            )}
                        />
                    </div>
                    <div className="form-item">
                        <label>{t("Experience.china_course")}</label>
                        <Select
                            mode="multiple"
                            style={{
                                width: '100%',
                            }}
                            size='large'
                            showSearch={false}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            placeholder={t("Experience.instruction")}
                            onChange={handleChinaCourseChange}
                            options={chinaCourseList(t)}
                            optionRender={(option) => (
                                <Space direction='vertical'>
                                    <span style={{ color: "#e67300" }}>
                                        {option.data.label}
                                    </span>
                                    <span style={{ color: "#575655" }}>
                                        {option.data.date}
                                    </span>
                                    <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                </Space>
                            )}
                        />
                    </div>
                    <div className="form-item">
                        <label>{t("Experience.taiwan_course")}</label>
                        <Select
                            mode="multiple"
                            style={{
                                width: '100%',
                            }}
                            size='large'
                            showSearch={false}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            placeholder={t("Experience.instruction")}
                            onChange={handleTaiwanCourseChange}
                            options={taiwanCourseList(t)}
                            optionRender={(option) => (
                                <Space direction='vertical'>
                                    <span style={{ color: "#e67300" }}>
                                        {option.data.label}
                                    </span>
                                    <span style={{ color: "#575655" }}>
                                        {option.data.date}
                                    </span>
                                    <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                </Space>
                            )}
                        />
                    </div>
                    <div className="form-item">
                        <label>{t("Experience.china_online_course")}</label>
                        <Select
                            mode="multiple"
                            style={{
                                width: '100%',
                            }}
                            size='large'
                            showSearch={false}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            placeholder={t("Experience.instruction")}
                            onChange={handleOnlineCourseChange}
                            options={chinaOnlineCourseList(t)}
                            optionRender={(option) => (
                                <Space direction='vertical'>
                                    <span style={{ color: "#e67300" }}>
                                        {option.data.label}
                                    </span>
                                    <span style={{ color: "#575655" }}>
                                        {option.data.date}
                                    </span>
                                    <Divider style={{ margin: '4px 0', color: '#000000' }} />
                                </Space>
                            )}
                        />
                    </div>
                    <div className='submit-button d-flex justify-content-center mt-4 gap-3'>
                        <Button buttonStyle='btn--primary' disabled={isSubmitting} onClick={handleSubmit} type="button">
                            {isSubmitting ? <AiOutlineLoading className="spin" /> : t("general.BTNsubmit")}
                        </Button>
                    </div>

                </form>
            </div>

        </>
    )
}

export default CreateExperience